import Wrapper from "../../../../components/layout/Wrapper";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faChevronLeft, faChevronRight} from "@fortawesome/free-solid-svg-icons";
import React from "react";
import Button from "../../../../components/elements/Button";

const FooterLesson = ({
                          goPrevious,
                          goNext,
                          hasPrevious = false,
                          hasNext = false,
                          isLastScreen = false,
                      }) => {
    return (
        <footer className='w-full flex items-center border-t-4 border-gray-200 py-5'>
            <Wrapper>
                <div className='flex items-center justify-between'>

                    <Button onClick={goPrevious} disabled={!hasPrevious}>
                        <FontAwesomeIcon icon={faChevronRight}/>
                        <span>قبلی</span>
                    </Button>

                    {/* On the last screen the button finishes the lesson instead of moving on */}
                    <Button onClick={goNext} disabled={!hasNext}>
                        <span>{isLastScreen ? "پایان درس" : "بعدی"}</span>
                        <FontAwesomeIcon icon={isLastScreen ? faCheck : faChevronLeft}/>
                    </Button>

                </div>
            </Wrapper>
        </footer>
    );
};

export default FooterLesson;